module.exports = "/_next/static/images/Frame2-9e5756127a1115c698ed1fc880d08224.webp";